<script>
  let colapsed = true;
</script>

<style>
  .colapsingpanel {
    border: 1px solid #333;
    margin: 5px;
  }
  .inline {
    display: inline-block;
    vertical-align: middle;
  }
  .caret {
    margin-left: 5px;
    margin-right: 2px;
  }
  .content {
    margin-left: 5px;
    margin-bottom: 5px;
  }
</style>

<div class="colapsingpanel" on:click={() => colapsed = !colapsed}>
  <div>
    <div class="caret inline">
      <i class="fas fa-lg" class:fa-caret-right={colapsed} class:fa-caret-down={!colapsed} aria-hidden="true" />
    </div>
    <div class="header inline">
      <slot name="header" />
    </div>
  </div>
  {#if !colapsed}
    <div class="content">
      <slot name="content" />
    </div>
  {/if}
</div>